import React from 'react';
import './hibuTextButton.scss';
import {IconType} from '../../icons/icons';
import {Button} from 'react-bootstrap';

type ButtonProps = {
    onClick?: () => void;
    disabled: boolean;
    label: string;
    icon?: IconType;
    filled?: boolean;
    type?: 'button' | 'submit' | 'reset';
}
export const HibuTextButton = React.memo(({
                                              label,
                                              icon,
                                              disabled = false,
                                              onClick,
                                              filled,
                                              type = 'button'
                                          }: ButtonProps) => {

    const children = (): JSX.Element => {
        if (!icon) {
            return <>{label}</>;
        }
        const Icon = icon as IconType;
        return <><Icon/> {label} </>;
    };

    return <>
        <Button className={`hibu-text-button ${disabled ? 'disabled' : ''} ${filled ? 'filled' : ''} ${type}`}
                onClick={onClick} type={type} disabled={disabled}>
            {children()}
        </Button>
    </>;
});
